import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import auth, { authEpic } from "reducers/auth";
import navbar from "reducers/navbar";
import footer from "reducers/footer";
import { calendarSyncReducer as calendarSync } from "reducers/calendarSync";
import { shrinkNavBarReducer as shrinkNavBar } from "reducers/shrinkNavBar";
import { calendar, toast, calendarRightMenu } from "@avamae/calendar-module";
import { chats, calls, translations } from "@avamae/communications-module";
import rightPanel from "./rightPanel";
import messages from "./messages";

export const rootReducer = combineReducers({
  auth,
  navbar,
  footer,
  calendar,
  rightPanel,
  toast,
  calendarRightMenu,
  calendarSync,
  shrinkNavBar,
  messages,
  chats,
  calls,
  translations,
});
export const rootEpic = combineEpics(authEpic);

export type Store = ReturnType<typeof rootReducer>;
